import * as Device from 'expo-device';

export const handleMoveShouldSetResponderCapture = (): boolean => {
  const modelIds = [
    // 'iPhone10,6',
    // 'iPhone11,2',
    // 'iPhone11,4',
    // 'iPhone11,6',
    'iPhone11,8',
    'iPhone12,1',
    'iPhone12,3',
    'iPhone12,5',
    'iPhone13,1',
    'iPhone13,2',
    'iPhone13,3',
    'iPhone13,4',
  ];
  return !!modelIds.includes(Device.modelId);
};
